export const ACTIVITY_FIELDS = ["call_logs", "text_logs", "meetings", "scheduled_calls", "comments"];

// Send only the list the user changed, along with the version they saw.
export function activityUpdate(before, after) {
  const payload = { activity_baseline: {} };
  for (const field of ACTIVITY_FIELDS) {
    if (JSON.stringify(before[field] || []) !== JSON.stringify(after[field] || [])) {
      payload[field] = after[field] || [];
      payload.activity_baseline[field] = before[field] || [];
    }
  }
  return payload;
}

// Only send deliberate edits. Keep raw stored values for the server's atomic check.
export function leadDetails(form, original) {
  if (!original) return form;
  const payload = { detail_baseline: {} };
  for (const [key, value] of Object.entries(form)) {
    if (ACTIVITY_FIELDS.includes(key) || ["status_history", "assigned_to_name"].includes(key)) continue;
    let displayed = original[key] || "";
    if (key === "status") displayed = original.status || "New";
    if (key === "notes") displayed = original.notes || original.caller_notes || "";
    if (key === "category") displayed = Array.isArray(original.category) ? original.category : (original.category ? [original.category] : []);
    if (JSON.stringify(value) !== JSON.stringify(displayed)) {
      payload[key] = value;
      payload.detail_baseline[key] = original[key] ?? null;
    }
  }
  return payload;
}
